export default {
    'pl': require('./pl.json'),
}


// WEBPACK FOOTER //
// ./src/locales/lang/DataTableComponent/index.js